module.exports = __webpack_public_path__ + "img/no-permission.5de338d9.png";